import React from 'react'

import './MartketingBanner.css'

const MartketingBanner = React.memo( () => (
	<div id='marketing-banner' />
) )

export default MartketingBanner
